import { debounce, getCookie, setCookie } from '@beef/utils';
import { CARD_TYPE } from "./constants";
var matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;

/** common methods defined by other libraries that can be possibly reused */

export var escapeStringRegexp = function escapeStringRegexp(string) {
  if (typeof string !== 'string') {
    return '';
  }
  return string.replace(matchOperatorsRegex, '\\$&');
};
export var getRecentlySearched = function getRecentlySearched(cookieName) {
  try {
    var data = getCookie(cookieName);
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.error(e);
    return [];
  }
};
export var addRecentlySearched = function addRecentlySearched(_ref) {
  var query = _ref.query,
    cookieName = _ref.cookieName,
    daysToExpire = _ref.daysToExpire,
    valuesNumber = _ref.valuesNumber;
  var cookieValue = getRecentlySearched(cookieName);
  var searchQuery = query.trim();
  if (searchQuery.length > 0 && !cookieValue.includes(searchQuery)) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    cookieValue.length === valuesNumber && cookieValue.pop();
    cookieValue.unshift(searchQuery);
    var ttl = daysToExpire * 60 * 60 * 24 * 1000;
    setCookie({
      name: cookieName,
      value: JSON.stringify(cookieValue.map(function (value) {
        return encodeURIComponent(value);
      })),
      ttl: ttl,
      path: '/'
    });
  }
};
export var addRecentlySearchedDebounce = debounce(2000, function (args) {
  addRecentlySearched(args);
});
export var prepareHistorySearch = function prepareHistorySearch(_ref2) {
  var cookieName = _ref2.cookieName,
    query = _ref2.query;
  var cookieValue = getRecentlySearched(cookieName);
  return query.trim() ? getOnlyBoldHighlightMapper(cookieValue, query) : cookieValue;
};
export var getOnlyBoldHighlightMapper = function getOnlyBoldHighlightMapper(items, string) {
  var textsWithBold = [];
  if (items !== null && items !== void 0 && items.length) {
    items.forEach(function (item) {
      var _item$toLowerCase;
      if ((_item$toLowerCase = item.toLowerCase()) !== null && _item$toLowerCase !== void 0 && _item$toLowerCase.includes(string.toLowerCase())) {
        textsWithBold.push(getBoldHighlight(item, string));
      }
    });
  }
  return textsWithBold;
};
var getBoldHighlight = function getBoldHighlight(text, string) {
  var reg = new RegExp("(".concat(escapeStringRegexp(string), ")"), 'gi');
  return text.replace(reg, '<span style="color: #98A0B0; font-weight: 500">$1</span>');
};
export var deleteHistoryItem = function deleteHistoryItem(_ref3) {
  var cookieName = _ref3.cookieName,
    daysToExpire = _ref3.daysToExpire,
    query = _ref3.query;
  var regex = /(|<([^>]+)>)/gi;
  var clearValue = query.replace(regex, '');
  var cookieValue = getRecentlySearched(cookieName);
  if (cookieValue.includes(clearValue)) {
    cookieValue = cookieValue.filter(function (item) {
      return item !== clearValue;
    });
    var ttl = daysToExpire * 60 * 60 * 24 * 1000;
    setCookie({
      name: cookieName,
      value: JSON.stringify(cookieValue.map(function (val) {
        return encodeURIComponent(val);
      })),
      ttl: ttl,
      path: '/'
    });
  }
};
export var convertHistoryToCell = function convertHistoryToCell() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return list.map(function (title) {
    return {
      title: title,
      category: CARD_TYPE.history
    };
  }).slice(0, 2);
};